module.exports = __webpack_public_path__ + "img/dalina_lopez.7f962dd4.jpg";